// src/lib/stack-app/apps/interfaces/client-app.ts
import { _StackClientAppImpl } from "../implementations";
var StackClientApp = _StackClientAppImpl;
export {
  StackClientApp
};
//# sourceMappingURL=client-app.js.map